<ph-skeleton *ngIf="isLoadingPayable" lines="6" label="Loading payable details"></ph-skeleton>

<ph-stack *ngIf="!isLoadingPayable && payable">
    <ph-toolbar justify="between">
        <strong>
            {{ payable.vendor?.name || 'Unknown vendor' }}
            <ng-container *ngIf="payable.vendor?.nickname">({{ payable.vendor.nickname }})</ng-container>
        </strong>
        <app-payable-status-badge [payable]="payable"></app-payable-status-badge>
    </ph-toolbar>
    <ph-divider></ph-divider>
</ph-stack>

<form *ngIf="!isLoadingPayable && payableForm"
      [formGroup]="payableForm"
      (ngSubmit)="onSubmit()"
      novalidate>
    <ph-stack>
        <ph-columns min="220px">
            <ph-field>
                <ph-label>Invoice date</ph-label>
                <ph-date-input formControlName="invoiceDate" ngDefaultControl placeholder="MM/DD/YYYY"></ph-date-input>
            </ph-field>
            <ph-field>
                <ph-label>Invoice due date</ph-label>
                <ph-date-input formControlName="dueDate" ngDefaultControl placeholder="MM/DD/YYYY"></ph-date-input>
            </ph-field>
        </ph-columns>

        <ph-columns min="220px">
            <ph-field>
                <ph-label>Invoice number</ph-label>
                <ph-input formControlName="invoiceNumber" ngDefaultControl placeholder="Invoice number"></ph-input>
            </ph-field>
            <ph-field>
                <ph-label>Invoice amount</ph-label>
                <ph-money-input formControlName="amount"
                                ngDefaultControl
                                validateDecimal
                                [hasError]="payableForm.get('amount')?.touched && (payableForm.get('amount')?.invalid || invalidControls.includes('splitAmountMismatch'))"></ph-money-input>
            </ph-field>
        </ph-columns>

        <app-expense-categories-form
            [parentFormGroup]="payableForm"
            [hasAccrualAccounting]="hasAccrualAccounting"
            [totalAmount]="totalAmount"
            [invalidControls]="invalidControls"
            [readonly]="false"
            [defaultCategory]="defaultCategory"
            [existingExpenseCategories]="payable?.expenseCategories || []"
            (expenseCategoriesLoadingChange)="onExpenseCategoriesLoadingChange($event)"
            (validationStateChange)="onExpenseCategoriesValidationChange($event)"
        ></app-expense-categories-form>

        <ph-field>
            <ph-label>Memo</ph-label>
            <ph-textarea formControlName="memo" ngDefaultControl rows="2" placeholder="Memo"></ph-textarea>
        </ph-field>

        <ng-container *ngIf="!isDraft">
            <ph-divider></ph-divider>
            <ph-hint *ngIf="isTreasuryAch">The transaction date and bank account are locked for Treasury Balance payments.</ph-hint>

            <ph-columns min="220px">
                <ph-field>
                    <ph-label>Scheduled payment date</ph-label>
                    <ph-date-input formControlName="scheduledPaymentDate" ngDefaultControl [min]="minDay" placeholder="MM/DD/YYYY"></ph-date-input>
                    <ph-hint>Payment processed at 11:55AM EST on the scheduled date.</ph-hint>
                </ph-field>
                <div>
                    <ph-field *ngIf="isCheck">
                        <ph-label>Check number</ph-label>
                        <ph-input formControlName="checkNumber"
                                  ngDefaultControl
                                  placeholder="Check #"
                                  [hasError]="payableForm.get('checkNumber')?.touched && payableForm.get('checkNumber')?.invalid"></ph-input>
                        <ph-hint>Check number must be between 1 and 500,000,000</ph-hint>
                        <lf-control-messages hint [control]="payableForm.get('checkNumber')"></lf-control-messages>
                    </ph-field>
                </div>
            </ph-columns>

            <ph-columns min="220px">
                <ph-field>
                    <ph-label>Transaction date</ph-label>
                    <ph-date-input formControlName="transactionDate" ngDefaultControl placeholder="MM/DD/YYYY"></ph-date-input>
                </ph-field>
                <ph-field>
                    <ph-label>Bank account</ph-label>
                    <app-bank-account-selector
                        [formGroup]="payableForm"
                        controlName="unifiedBankAccountId"
                        [accountId]="payable?.currentFulfillment?.fundingBankAccount?.id"
                        [allowCreate]="false"
                        [onlyDeposit]="false"
                        [verified]="requiresVerifiedBankAccount"
                    ></app-bank-account-selector>
                    <ph-hint *ngIf="requiresVerifiedBankAccount">Payment method requires a verified bank account.</ph-hint>
                </ph-field>
            </ph-columns>
        </ng-container>
    </ph-stack>
</form>
